import { useState } from 'react';
import './user-menu.css';
import { DEFAULT_AVATAR_URL, handleAvatarLoadError } from '../../../shared/lib/avatarFallback';
import {Link, useNavigate} from 'react-router-dom';
import DonationBtn from '../../../shared/ui/DonationBtn/DonationBtn';
import { endSession } from '../../../shared/lib/auth/session';
import { ReactComponent as TemplateIcon } from '../../../features/select-repeat-template/lib/icons/repeatTemplate_icon.svg'
import { ReactComponent as TemplateTaskIcon } from "../lib/icons/task-template-icon-small.svg"
import { useDispatch } from 'react-redux';
import { UserAuthActionTypes } from '../../../features/user/userStore';
import { ProjectSupportComponent } from '../../../features/project-support';
import { CSSTransition } from 'react-transition-group';

export const UserMenu = ({active, setActive, avatar}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false)

    function Logout() {
        endSession();
        setActive(false);
        dispatch({type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT});
        navigate('/login', {require: true});
    }
    
    return(
        <>
            {
            modalShow &&
            <ProjectSupportComponent modal={modalShow} setModal={setModalShow}/>
          }
        <CSSTransition
            in={active}
            timeout={200}
            classNames='menus-animation-tmp'
            unmountOnExit
        >
            <div className='user-menu-dropdown'>
                <div className='user-menu-content'>
                        <div className='a-list-menu__person-data'>
                            <img className='user-avatar' src={avatar || DEFAULT_AVATAR_URL} onError={handleAvatarLoadError} alt=''/>
                            <div className='a-list-menu__person-info'>
                                <div className='a-list-menu__person-name'>
                                    <p>{localStorage.getItem('firstName')}</p>
                                    <p>{localStorage.getItem('lastName')}</p>
                                </div>
                                <div className='a-list-menu__person-post'>
                                    <p>{localStorage.getItem('position')}</p>
                                </div>
                            </div>
                        </div>
                    <ul className='a-list-menu'>
                        <Link to="/profile" 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-1'/>
                                Профиль
                        </Link>
                        <Link to='/statistics' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-2'/>
                                Статистика
                        </Link>
                        <Link to='/settings' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-3'/>
                                Настройки
                        </Link>
                        <Link to='/completed' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-4'/>
                                Выполненные
                        </Link>
                        <Link to='/removed_todo' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-5'/>
                                Корзина
                        </Link>
                        <Link to='/tags' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <span className='bg_menu-6'/>
                                Метки
                        </Link>
                        <Link to='/automation' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <TemplateIcon className='bg_menu-9'/>
                                Автоматизация
                        </Link>
                        <Link to='/templates' 
                            className='a-menu a-item-menu' 
                            onClick={() => setActive(false)}>
                                <TemplateTaskIcon className='bg_menu-9'/>
                                Шаблоны задач
                        </Link>
                        {/* <li className='a-item-menu'>
                                <span className='bg_menu-7'/>
                                <span className='a-menu' href="#">Премиум</span>
                        </li> */}
                        <li className="a-item-menu user-menu-logout">
                            <button type="button" className="a-menu" onClick={Logout}>
                                <span className="bg_menu-8" aria-hidden="true" />
                                Выйти
                            </button>
                        </li>
                    </ul>
                    <div style={{display: 'flex', justifyContent:'center'}} onClick={() => setActive(false)}>
                        <DonationBtn
                            updateModal={setModalShow}
                            title='Поддержать проект'/>
                    </div>
                </div>
            </div>
        </CSSTransition>
        </>
    )
}
